"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadeRootSize = void 0;
var _constants = require("../constants");
var _types = require("../types");
const getShadeRootSize = (size, border, isCurrent) => {
  let rootSize = 0;
  switch (size) {
    case _types.ShadeSize.Small:
      rootSize = _constants.SHADES_SMALL_SIZE;
      break;
    case _types.ShadeSize.Inline:
      rootSize = _constants.SHADES_INLINE_SIZE;
      break;
    default:
      rootSize = isCurrent ? _constants.SHADES_SIZE_CURRENT : _constants.SHADES_SIZE;
  }
  if (border !== undefined) {
    rootSize -= 2;
  }
  return `${rootSize}px`;
};
exports.getShadeRootSize = getShadeRootSize;
